import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify, {
  iconfont: 'mdi'
})

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#53599a',
        secondary: '#222e50',
        accent: '#ffc459',
        error: '#b71c1c',
        info: '#288ca0',
        success: '#5fb6cc',
        warning: '#ffc459'
      }
    }
  }
})
